




































































import Vue from 'vue'
// @ts-ignore
import _ from 'lodash'
import { TranslateResult } from 'vue-i18n'
import { KeyActionEnum, SnackbarStateEnum } from '@/types/enums'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import NumberField from '@/components/NumberField.vue'
import { KeyAction } from '@/model/KeyAction'
import { keyActionService } from '@/services/key-action-service'
import ProductSalesAndBudgetGraph from '@/components/master-data/product/ProductSalesAndBudgetGraph.vue'
import moment from 'moment'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}

interface ComponentData {
  loading: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  tableHeight: string
  valid: boolean
  inSaveProgress: boolean
  isCreate: boolean
  isUpdate: boolean

  umsatzartList: any[]
  umsatzart: any | null
  projektartList: any[]
  projektart: any | null
  optionen: any
  jahrList: string[]
  jahr: string
  months: any[]
  budget: number
  umsatz: number

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'ProductSalesAndBudget',

  components: {
    NumberField,
    ProductSalesAndBudgetGraph
  },

  props: {
    productId: Number
  },

  data (): ComponentData {
    //const required = (value: any): boolean | string => !!value || ''

    return {
      loading: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      tableHeight: '',
      valid: true,
      inSaveProgress: false,
      isCreate: false,
      isUpdate: false,

      umsatzartList: [],
      umsatzart: null,
      projektartList: [],
      projektart: null,
      optionen: 1,
      jahrList: [],
      jahr: '2025',
      months: [
        {id: 1, value: null, label: 'Jan'},
        {id: 2, value: null, label: 'Feb'},
        {id: 3, value: null, label: 'Mar'},
        {id: 4, value: null, label: 'Apr'},
        {id: 5, value: null, label: 'Mai'},
        {id: 6, value: null, label: 'Jun'},
        {id: 7, value: null, label: 'Jul'},
        {id: 8, value: null, label: 'Aug'},
        {id: 9, value: null, label: 'Sep'},
        {id: 10, value: null, label: 'Okt'},
        {id: 11, value: null, label: 'Nov'},
        {id: 12, value: null, label: 'Dez'},
      ],
      budget: 0.00,
      umsatz: 0.00,

      keyActions: []
    }
  },

  watch: {
    productId (newVal: number): void {
      if(newVal && newVal !== 0) {
        this.fetchData()
        this.fetchMetadata()
      }
    },
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },


  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | null): boolean {
      if(action instanceof Create) {
        return true
      } else if(action instanceof Edit) {
        return true
      } else if(action instanceof Delete) {
        return true
      } else {
        return false
      }
    },

    onMonthChange (item: any): void {
      if(item.value == null || item.value < 0) {
        item.value = 0
      }
    },

    onBudgetChange (): void {
      if(this.budget == null || this.budget < 0) {
        this.budget = 0.00
      }
    },

    onUmsatzChange (): void {
      if(this.umsatz == null || this.umsatz < 0) {
        this.umsatz = 0.00
      }
    },

    onRowClick (): void {

    },

    onCreateClick ():void {
      this.create()
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }
      this.isCreate = true
      this.isUpdate = false
      /*if(this.activeTab === 0) {
        this.storageData = null
        this.selectedLagerungenId = 0
        //@ts-ignore
        this.$refs.dataGrid.instance.selectRows([])
      }*/
    },

    onUpdateClick ():void {
      this.update()
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }
      /*if(this.activeTab === 0) {
        if (this.selectedLagerungenId) {
          this.isUpdate = true
        }
      }*/

      this.isCreate = false
    },

    onDeleteClick ():void {
      this.delete()
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }
      this.isCreate = false
      this.isUpdate = false

      /*if(this.activeTab === 0) {
        this.deleteProductStorage()
      }*/
    },

    onRefreshClick (): void {

    },

    onCalculateSalesClick (): void {

    },

    onCalculateBudgetClick (): void {

    },

    onCopyClick (): void {

    },

    onCancelClick (): void {

    },

    fetchData (): void {

    },

    fetchMetadata (): void {

    },

    onResize (): void {
      const vh = window.innerHeight
      if(vh > 550) {
        this.tableHeight = `height: calc(${vh}px - 300px)`
      } else {
        this.tableHeight = 'height: 300px'
      }
    },
  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
    ]
  },

  mounted () {
    window.addEventListener('keydown', this.onKeydown)
    this.jahr = moment().format('YYYY')
    this.jahrList.push(moment().format('YYYY'))
    for (let i = 1; i < 6; i++) {
      this.jahrList.push(moment().subtract(i, 'year').format('YYYY'))
    }
    this.jahrList.push(moment().format('YYYY'))
    for (let i = 1; i < 6; i++) {
      this.jahrList.push(moment().add(i, 'year').format('YYYY'))
    }
    this.jahrList.sort((a, b) => Number(a) - Number(b))

    this.fetchData()
    this.fetchMetadata()
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }

})
